<span [dir]="options.dir!">
<mat-sidenav-container class="mainWrapper" autosize autoFocus [ngClass]="{
      'sidebarNav-mini':
        options.sidenavCollapsed && options.navPos !== 'top' && !resView,
      'sidebarNav-horizontal': options.horizontal,
      cardBorder: options.cardBorder
    }">
<!-- ============================================================== -->
<!-- Vertical Sidebar -->
<!-- ============================================================== -->
@if (!options.horizontal) {
<mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="
        options.navPos === 'side' &&
        options.sidenavOpened &&
        !isOver &&
        !resView
      " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
  <div class="flex-layout flex flex-col h-full">
    <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
    <ng-scrollbar class="relative" visibility="hover" appearance="compact" style="height: 100%">
      <mat-nav-list class="sidebar-list">
        @for(item of navItems; track item) {
        <app-nav-item [item]="item" (notify)="sidenav.toggle()" class="top-parent">
        </app-nav-item>
        }
      </mat-nav-list>
    </ng-scrollbar>
    <!-- <div class="p-6 mt-auto profile-bar">
      <div class="bg-light-secondary flex items-center rounded-sm p-4">
        <img src="/assets/images/profile/user-1.jpg" class="rounded-full" width="40" />
        <div class="ms-4 leading-5">
          <h4 class="font-semibold leading-5">Mathew</h4>
          <span class="text-xs leading-5">Designer</span>
        </div>
        <div class="ms-auto">
          <button mat-icon-button (click)="logout()" class="flex justify-center">
            <i class="iconify text-lg flex!" data-icon="solar:power-linear"></i>
          </button>
        </div>
      </div>
    </div> -->
  </div>
</mat-sidenav>
}

<!-- ============================================================== -->
<!-- horizontal Sidebar -->
<!-- ============================================================== -->
<!-- Só no layout horizontal: no vertical o sidenav acima já cobre o modo mobile.
     Dois mat-sidenav na mesma posição fazem o MatDrawerContainer lançar
     "A drawer was already declared for position start", o que deixa o container
     sem o backdrop e sem o fechamento ao clicar fora. -->
@if (resView && options.horizontal) {
<mat-sidenav #leftsidenav [mode]="'over'" [opened]="options.sidenavOpened && !isTablet"
             (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
  <app-sidebar> </app-sidebar>
  <ng-scrollbar class="relative"  style="height: 100%">
    <mat-nav-list class="sidebar-list">
      @for(item of navItems; track item) {
      <app-nav-item [item]="item" (notify)="sidenav.toggle()">
      </app-nav-item>
      }
    </mat-nav-list>
  </ng-scrollbar>
  <div class="p-6 mt-auto profile-bar">
    <div class="bg-light-secondary flex items-center rounded-sm p-4">
      <img src="/assets/images/profile/user-1.jpg" class="rounded-full" width="40"/>
      <div class="ms-4 leading-5">
        <h4 class="font-semibold leading-5">Mathew</h4>
        <span class="text-xs leading-5">Designer</span>
      </div>
      <div class="ms-auto">
        <button mat-icon-button (click)="logout()" class="flex justify-center">
          <i class="iconify text-lg flex!" data-icon="solar:power-linear"></i>
        </button>
      </div>
    </div>
  </div>
</mat-sidenav>
}

<!-- ============================================================== -->
<!-- Main Content -->
<!-- ============================================================== -->
<mat-sidenav-content class="contentWrapper" #content>
  <!-- ============================================================== -->
  <!-- VerticalHeader -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
  <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="sidenav.toggle()"
              (toggleMobileFilterNav)="toggleFilterNav()" (optionsChange)="receiveOptions($event)">
  </app-header>
  } @else {
  <app-horizontal-header (toggleMobileNav)="sidenav.toggle()" (toggleMobileFilterNav)="toggleFilterNav()"
                         (optionsChange)="receiveOptions($event)">
  </app-horizontal-header>
  } @if(options.horizontal) {
  <app-horizontal-sidebar></app-horizontal-sidebar>
  }

  <main class="pageWrapper" [ngClass]="{
          maxWidth: options.boxed
        }">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <!-- ============================================================== -->
    <!-- Outlet -->
    <!-- ============================================================== -->
    <router-outlet></router-outlet>
    <!-- <div class="fixed bottom-7 right-7 rtl:right-auto rtl:left-7 z-10">
      <button mat-fab class="bg-primary text-white!" (click)="customizerRight.toggle()">
        <mat-icon>settings</mat-icon>
      </button>
    </div> -->
  </main>

  <!-- ------------------------------------------------------------------
  Mobile Bottom Navigation
  ------------------------------------------------------------------ -->
  @if(resView) {
  <nav class="mobile-bottom-nav">
    <button class="mobile-bottom-nav__item" (click)="sidenav.toggle()">
      <i class="iconify" data-icon="solar:hamburger-menu-line-duotone"></i>
      <span>{{ 'Menu' | transloco }}</span>
    </button>


    <button class="mobile-bottom-nav__item"
            (click)="eventsService.emit('command:new')">
      <i class="iconify text-4xl! opacity-80 text-primary" data-icon="solar:add-square-linear"></i>
      <!-- <i class="iconify text-4xl! opacity-80 text-primary" data-icon="solar:add-square-bold"></i> -->
    </button>

        <a routerLink="/dashboards/dashboard1" class="mobile-bottom-nav__item" routerLinkActive="active">
      <i class="iconify" data-icon="solar:widget-line-duotone"></i>
      <span>{{ 'Home' | transloco }}</span>
    </a>

<!--
        <a routerLink="/admin/agents/list" class="mobile-bottom-nav__item">
      <i class="iconify" data-icon="solar:users-group-rounded-line-duotone"></i>
      <span>{{ 'Agents' | transloco }}</span>
    </a>

    <a routerLink="/admin/users/all" class="mobile-bottom-nav__item" routerLinkActive="active">
      <i class="iconify" data-icon="solar:settings-line-duotone"></i>
      <span>{{ 'Admin' | transloco }}</span>
    </a> -->

  </nav>
  }

  <!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
  <div [class.open]="isFilterNavOpen"
       class="filter-sidebar w-[290px] fixed -right-[290px] top-0 z-10 h-full transition-all duration-300 ease-in-out shadow-(--mat-sys-level1) bg-(--mat-sys-background)">
    <div>
      <div class="flex justify-between items-center">
        <div class="branding px-2!">
          @if(options.theme === 'light') {
          <a href="/">
            <img [src]="options.logoDark" class="align-middle m-2 rtl:-scale-x-100" alt="logo"/>
          </a>
          } @else {
          <a href="/">
            <img [src]="options.logoLight" class="align-middle m-2 rtl:-scale-x-100" alt="logo"/>
          </a>
          }
        </div>
        <button mat-icon-button (click)="isFilterNavOpen = !isFilterNavOpen" class="flex justify-center">
          <i-tabler name="x" class="size-4.5! flex!"></i-tabler>
        </button>
      </div>

      <mat-accordion>
        <mat-expansion-panel class="shadow-none!">
          <mat-expansion-panel-header>
            <mat-panel-title class="text-base font-medium"> Apps </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="grid grid-cols-12 gap-6">
              @for(appdd of apps; track appdd.img) {
              <div class="col-span-12 text-hover-primary">
                <a [routerLink]="[appdd.link]" class="flex items-center no-underline gap-4">
                  <button mat-mini-fab class="text-primary bg-light-primary shadow-none! rounded-sm">
                    <img [src]="appdd.img" width="20"/>
                  </button>

                  <div>
                    <h5 class="text-sm font-semibold m-0 textprimary hover-text">
                      {{ appdd.title }}
                    </h5>
                    <span class="text-sm">{{ appdd.subtitle }}</span>
                  </div>
                </a>
              </div>
              }
            </div>
            <h4 class="text-lg font-semibold my-4">Quick Links</h4>
            @for(quicklink of quicklinks; track quicklink.title) {
            <div class="text-hover-primary">
              <a [routerLink]="['quicklink.link']"
                 class="hover-text no-underline text-sm font-semibold block py-2">
                {{ quicklink.title }}
              </a>
            </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="px-4">
        <a [routerLink]="['/apps/calendar']" class="flex items-center no-underline text-sm py-2 gap-8">
          <span class="text-base font-medium ms-2">Calendar</span>
        </a>
        <a [routerLink]="['/apps/chat']" class="flex items-center no-underline text-sm py-2">
          <span class="text-base font-medium ms-2">Chat</span>
        </a>
        <a [routerLink]="['/apps/email/inbox']" class="flex items-center no-underline text-sm py-2 gap-8">
          <span class="text-base font-medium ms-2">Email</span>
        </a>
      </div>
    </div>
  </div>
</mat-sidenav-content>

<mat-sidenav #customizerRight mode="over" position="end">
  <div class="px-4 py-5 flex items-center justify-between">
    <h3 class="text-xl font-semibold">Settings</h3>
    <button class="lg:hidden" mat-button (click)="customizerRight.toggle()">
      Close
    </button>
  </div>
  <mat-divider></mat-divider>

  <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
</mat-sidenav>
</mat-sidenav-container>
</span>
